import { render } from "./SaveTrim.vue?vue&type=template&id=261054d8"
import script from "./SaveTrim.vue?vue&type=script&lang=js"
export * from "./SaveTrim.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__